import * as yup from 'yup';

export const hazmatDeclarationSchema = yup.object().shape({
	agreed: yup.bool(true).oneOf([true], 'Field must be checked'),
	title: yup.string().required('Title is required.'),
	phone: yup.string().required('Phone number is required.'),
	email: yup.string().email().required('Email is required.'),
	name: yup.string().required('Name is required.'),
});
